// @ts-strict

import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { countries } from '@app/core/helpers/countries';
import { StatisticsMapItem } from '@pages/statistics/shared/interfaces/statistics';
import { StatisticsSummaryService } from '@services/statistics/statistics-summary.service';
import { isUndefined } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
@Component({
  selector: 'app-country-details-data',
  templateUrl: './country-details-data.component.html',
  styleUrls: ['./country-details-data.component.scss']
})
export class CountryDetailsDataComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectedCountry?: StatisticsMapItem & { earnings?: number };
  @Input() selectedCompareCountry?: StatisticsMapItem & { earnings?: number };
  @Input() compareMode = false;

  @Output() closeDetailsPopUp = new EventEmitter<boolean>();

  public earningsPercentChange = 0;
  public visitsPercentChange = 0;
  public leadsPercentChange = 0;
  public leadsSumPercentChange = 0;
  public conversionPercentChange = 0;

  public countryNameID = 0;
  public countryName = '';
  public currentURL = '';

  public detailsLabels = [
    { name: 'earnings', translations: 'view_translations.earnings', percentChange: 'earningsPercentChange' },
    { name: 'visits', translations: 'view_translations.visits', percentChange: 'visitsPercentChange' },
    { name: 'leads_accepted_sum', translations: 'view_translations.leads', percentChange: 'leadsSumPercentChange' },
    // { name: 'leads', translations: 'view_translations.leads', percentChange: 'leadsPercentChange' },
    { name: 'conversion', translations: 'view_translations.conversion', percentChange: 'conversionPercentChange' }
  ];

  private destroy$ = new Subject<void>();

  constructor(private statistics: StatisticsSummaryService, private router: Router) {}

  ngOnInit(): void {
    this.currentURL = this.router.url;
    this.statistics.compareMode
      .pipe(
        tap(res => {
          this.compareMode = res.compareMode;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();

    if (this.selectedCountry) {
      this.detailsLabels = this.detailsLabels.filter(({ name }) => Object.keys(this.selectedCountry!).includes(name));
    }
  }

  ngOnChanges(): void {
    if (this.selectedCountry) {
      this.getCountryIDbyKey(this.selectedCountry);
      this.calculateEarnings(this.selectedCountry);
      this.detailsLabels = this.detailsLabels.filter(({ name }) => Object.keys(this.selectedCountry!).includes(name));
    }

    if (this.selectedCompareCountry) {
      this.calculateEarnings(this.selectedCompareCountry, true);
    }

    if (this.selectedCountry && this.compareMode) {
      this.getPercentChange();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public closePopupDetails(): void {
    this.closeDetailsPopUp.emit(true);
  }

  public redirectToCountries(): void {
    this.router.navigate(['/statistics-and-reports', 'countries']);
    // setTimeout(() => {
    //   this.statistics.compareModeHandler(true, {});
    // }, 2000);
  }

  private getCountryIDbyKey(countryObj: StatisticsMapItem): void {
    let i = 0;
    for (const [key, value] of Object.entries(countries)) {
      i++;
      if (key.toLocaleLowerCase() === countryObj.country_code.toLowerCase()) {
        this.countryName = key.toLowerCase();
        this.countryNameID = i;
      }
    }
  }

  private calculateEarnings = (item: StatisticsMapItem, compare = false) => {
    const { earnings_status_payment_waiting, earnings_status_wait, earnings_status_to_payment } = item;

    if (isUndefined(earnings_status_payment_waiting) && isUndefined(earnings_status_wait) && isUndefined(earnings_status_to_payment)) {
      this.detailsLabels = this.detailsLabels.filter(({ name }) => name !== 'earnings');

      return;
    }

    const totalEarnings =
      parseFloat(earnings_status_payment_waiting ?? '0.00') + parseFloat(earnings_status_wait ?? '0.00') + parseFloat(earnings_status_to_payment ?? '0.00');

    const earnings = Number(totalEarnings.toFixed(2));

    const countryWithCalculatedEarnings = {
      ...item,
      earnings
    };

    compare ? (this.selectedCompareCountry = countryWithCalculatedEarnings) : (this.selectedCountry = countryWithCalculatedEarnings);
  };

  private getPercentChange(): void {
    const compareColumnsList: (keyof (StatisticsMapItem & { earnings?: number }))[] = ['earnings', 'visits', 'leads_accepted_sum', 'conversion'];

    compareColumnsList.map(el => {
      if (this.selectedCompareCountry && this.selectedCountry) {
        const compareValue = this.selectedCompareCountry[el] as number;
        const value = this.selectedCountry[el] as number;

        const percentChange = ((compareValue - value) / compareValue) * -100;

        if (isNaN(percentChange)) {
          return this.setPercentChange(el, 0);
        }

        if (percentChange === Infinity) {
          return this.setPercentChange(el, 100);
        }

        return this.setPercentChange(el, percentChange);
      }

      return this.setPercentChange(el, 0);
    });
  }

  private setPercentChange = (name: string, percentChange: number) => {
    switch (name) {
      case 'earnings':
        this.earningsPercentChange = percentChange;
        break;
      case 'visits':
        this.visitsPercentChange = percentChange;
        break;
      case 'leads':
        this.leadsPercentChange = percentChange;
        break;
      case 'leads_accepted_sum ':
        this.leadsSumPercentChange = percentChange;
        break;
      case 'conversion':
        this.conversionPercentChange = percentChange;
        break;
    }
  };
}
